import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

import { VendorMonthlySummary } from '~/types/services/vendor';

export const vendorMonthlySummaryQueryKeys = {
  all: ['vendor-monthly-summary'] as const,
  detail: (vendorId: string, month: string) => [...vendorMonthlySummaryQueryKeys.all, vendorId, month] as const,
};

type Params = {
  vendorId: string | null;
  month: string;
  enabled?: boolean;
};

export function useGetMonthlyVendorSummary({ vendorId, month, enabled = true }: Params) {
  return useQuery({
    queryKey: vendorMonthlySummaryQueryKeys.detail(vendorId ?? '', month),
    queryFn: async ({ signal }): Promise<VendorMonthlySummary> => {
      if (!vendorId) throw new Error('vendorId is required');
      const response = await VendorsService.getMonthlySummary(vendorId, month, { signal });
      return response.data;
    },
    enabled: enabled && !!vendorId && !!month,
    staleTime: 5 * 60 * 1000,
  });
}
